import { useState } from 'react';

// «İlk addımlar» (KT-84): dəvətlə qeydiyyatdan sonra sahibə — mallar, işçilər və PİN, kassa və cihaz, ilkin qalıq.
// «Gizlət» brauzerdə şirkət üzrə yadda qalır (yalnız rahatlıq; məlumat deyil).

interface Step {
  label: string;
  hint: string;
  onOpen: () => void;
}

function storageKey(tenantId: string): string {
  return `kassa.firstSteps.hidden.${tenantId}`;
}

export function FirstSteps({ tenantId, steps }: { tenantId: string; steps: Step[] }) {
  const [hidden, setHidden] = useState(() => {
    try {
      return window.localStorage.getItem(storageKey(tenantId)) === '1';
    } catch {
      return false;
    }
  });
  if (hidden || steps.length === 0) return null;
  function hide() {
    try {
      window.localStorage.setItem(storageKey(tenantId), '1');
    } catch {
      // brauzer yaddaşı bağlıdırsa yalnız bu səhifədə gizlənir
    }
    setHidden(true);
  }
  return (
    <section className="card first-steps" aria-label="İlk addımlar">
      <div className="toolbar">
        <h2>İlk addımlar</h2>
        <span className="topbar-spacer" />
        <button type="button" className="btn-small" onClick={hide}>
          Gizlət
        </button>
      </div>
      <ol>
        {steps.map((s) => (
          <li key={s.label}>
            <button type="button" className="link-btn dark" onClick={s.onOpen}>
              {s.label}
            </button>
            <div className="muted small">{s.hint}</div>
          </li>
        ))}
      </ol>
    </section>
  );
}
